import { TrashLight, ViewAltLight, ViewHideLight, ChooseRow, RefreshLight } from '@repo/go-icons';
import { Button } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { AnomaliesModeSelector } from '../components/AnomaliesModeSelector';
import { Toolbar, ToolbarItem, ToolbarSeparator } from '../components/Toolbar/Toolbar';
import { ViewSelector } from '../components/ViewSelector';
import type { ViewStore } from '../stores/ViewStore';

type Props = {
  viewStore: ViewStore;
  contextHidden: boolean;
  onToggleContext: () => void;
  hasUpdates: boolean;
  onRefresh: () => void;
  onDelete: () => void;
  deleteDisabled?: boolean;
  editing: boolean;
  onToggleSelectionMode: () => void;
};

export const AutoAnomaliesTableToolbar = observer(function AutoAnomaliesTableToolbar({
  viewStore,
  contextHidden,
  onToggleContext,
  hasUpdates,
  onRefresh,
  onDelete,
  deleteDisabled,
  editing,
  onToggleSelectionMode,
}: Props) {
  const { t } = useTranslation();

  return (
    <Toolbar>
      <ToolbarItem>
        <ViewSelector viewStore={viewStore} disabled={editing} />
      </ToolbarItem>
      <ToolbarSeparator />
      <ToolbarItem>
        <AnomaliesModeSelector viewStore={viewStore} disabled={editing} />
      </ToolbarItem>
      {hasUpdates && (
        <ToolbarItem>
          <Button variant="primary" icon={<RefreshLight />} onClick={onRefresh}>
            {t('alertsManagerWidget:autoAnomalies.refresh')}
          </Button>
        </ToolbarItem>
      )}
      <ToolbarItem toRight>
        <Button
          variant="flat"
          onClick={onToggleContext}
          icon={contextHidden ? <ViewAltLight /> : <ViewHideLight />}
          style={{ width: 160 }}
        >
          {contextHidden
            ? t('alertsManagerWidget:autoAnomalies.showContext')
            : t('alertsManagerWidget:autoAnomalies.hideContext')}
        </Button>
      </ToolbarItem>
      {editing && (
        <ToolbarItem>
          <Button
            variant="danger"
            icon={<TrashLight />}
            onClick={onDelete}
            disabled={deleteDisabled}
            title={t('alertsManagerWidget:autoAnomalies.delete')}
          />
        </ToolbarItem>
      )}
      {!editing && (
        <ToolbarItem>
          <Button
            variant="primary"
            icon={<ChooseRow />}
            onClick={onToggleSelectionMode}
            title={t('alertsManagerWidget:autoAnomalies.selectRows')}
          />
        </ToolbarItem>
      )}
    </Toolbar>
  );
});
